import {
  getUniqueShipmentDeliveryCodes,
  getMinutesInHourAndMinutesStr,
  getStopServiceWindow,
} from "../../util";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import { getStopDetails } from "./utils";
import constants from "./constants"
const DeliveryReturnStopPopup = ({ task }) => {
  const { stopStatus, stopStatusClass } = getStopDetails(task.data);
  const stopStatusCodes = getUniqueShipmentDeliveryCodes(task.data).join(",");
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      isReturn
      stopName={task?.data?.name}
      arrivalTime={task.arrivalTime}
      departureTime={task.departureTime}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={stopStatusClass}
      serviceWindow={getStopServiceWindow(task?.data)}
      statusCodes={stopStatusCodes}
    />
  );
};

export default DeliveryReturnStopPopup;
